const UploadRecipientsFormResources = {
    headerUploadRecipients: 'Upload Recipients',
    labelRecipientsFile: 'Recipient File Upload',
};
export default UploadRecipientsFormResources;
